import React from 'react';
import "./privacy.css";
const PrivacyPolicy = () => {
  return (
    <div className="tk-privacy-wrapper">
      {/* Premium Hero Banner Block */}
      <section className="tk-privacy-hero">
        <div className="container-fluid tk-privacy-fluid-container">
          <div className="tk-badge-privacy">DATA SECURITY & TRUST</div>
          <h1 className="tk-hero-main-title">
            Privacy Policy
            <span className="tk-hero-subtitle">DMT Group of Companies</span>
            <span className="tk-hero-lead-text">
              DMT Empire India Private Limited and its group entities are committed to protecting and respecting the privacy, confidentiality, and security of every individual’s Personal Information.
            </span>
          </h1>
        </div>
      </section>

      {/* Main Content Framework */}
      <section className="tk-privacy-body pb-5">
        <div className="container tk-privacy-container">
          <div className="row">
            
            <div className="col-lg-12">
              <div className="tk-privacy-card">
                
                {/* Introduction / Policy Context */}
                <div className="tk-privacy-intro">
                  <p>
                    This Privacy Policy (“Policy”) applies to all visitors, users, customers, merchants, partners, agents, and any other individuals (<strong>“Users”</strong>) who access, browse, register, or use the websites, mobile applications, products, platforms, and services operated by <strong>DMT Group</strong>, including but not limited to <strong>DMT Kendra</strong>, <strong>Coupon Fares</strong>, <strong>Finwelco</strong>, and <strong>Shardajeet Foundation</strong> (collectively referred to as the <strong>“Platform”</strong> or <strong>“Services”</strong>).
                  </p>
                  <p className="mb-0">
                    This Policy explains how DMT Group collects, receives, stores, processes, uses, transfers, shares, protects, and discloses User information in compliance with applicable Indian laws, including the <strong>Information Technology Act, 2000</strong>, the <strong>Information Technology (Reasonable Security Practices and Procedures and Sensitive Personal Data or Information) Rules, 2011</strong>, and other applicable regulations.
                  </p>
                </div>

                <hr className="tk-privacy-divider" />

                {/* Section 1 */}
                <div className="tk-legal-section">
                  <h3 className="tk-section-title">1. Information We Collect</h3>
                  <p>DMT Group may collect, receive, process, and store the following categories of information:</p>
                  
                  <div className="tk-sub-category-block">
                    <h5 className="tk-sub-title">a. Personal Information</h5>
                    <p>Information capable of identifying an individual directly or indirectly, including:</p>
                    <ul className="tk-legal-list">
                      <li>Full name, Date of birth, and Photographs</li>
                      <li>Residential or business address, Mobile number, and Email address</li>
                      <li>PAN details, Masked identity verification data, and KYC information</li>
                      <li>Business or firm information and supporting compliance documentation</li>
                    </ul>
                  </div>

                  <div className="tk-sub-category-block mt-3">
                    <h5 className="tk-sub-title">b. Sensitive Personal Data or Information (SPDI)</h5>
                    <p>As defined under applicable law, including:</p>
                    <ul className="tk-legal-list security-bullet">
                      <li>Passwords and secure login credentials</li>
                      <li>Financial information such as bank account details, debit/credit card information, UPI details, and payment instrument details</li>
                      <li>Biometric information where applicable for system authentication</li>
                      <li>Transaction-related history, logs, and authentication credentials including OTPs and PINs</li>
                    </ul>
                  </div>

                  <div className="tk-sub-category-block mt-3">
                    <h5 className="tk-sub-title">c. Technical & Usage Information</h5>
                    <p>We may automatically collect:</p>
                    <ul className="tk-legal-list network-bullet">
                      <li>IP address, Browser type, and Device identification details</li>
                      <li>Operating system information and Location parameters</li>
                      <li>Website activity logs, browsing patterns, Cookies, and core analytics data</li>
                    </ul>
                  </div>
                </div>

                {/* Section 2 */}
                <div className="tk-legal-section">
                  <h3 className="tk-section-title">2. Purpose of Collection</h3>
                  <p>DMT Group collects and processes information for lawful business purposes including:</p>
                  <ul className="tk-legal-list check-bullet">
                    <li>Creation and management of User accounts and verification of identity (KYC compliance).</li>
                    <li>Providing fintech, travel, marketing, and digital micro-transaction ecosystem services.</li>
                    <li>Processing financial transactions, settlement distribution workflows, and customer grievance handling.</li>
                    <li>Enhancing Platform security, network auditing, and proactive fraud prevention.</li>
                    <li>Compliance with legal, regulatory, RBI guidelines, NPCI rules, and audit obligations.</li>
                  </ul>
                </div>

                {/* Section 3 */}
                <div className="tk-legal-section">
                  <h3 className="tk-section-title">3. User Consent</h3>
                  <p>By accessing or using the Platform, the User expressly consents to the collection, storage, processing, transfer, and use of their Personal Information and SPDI for the purposes mentioned in this Policy.</p>
                  <p className="tk-sub-note">📌 Where required under law, separate or explicit consent may be obtained before collecting sensitive information. If the User is below 18 years of age, it is presumed that consent has been obtained from the parent or lawful guardian.</p>
                </div>

                {/* Section 4 */}
                <div className="tk-legal-section">
                  <h3 className="tk-section-title">4. Sharing & Disclosure of Information</h3>
                  <p>DMT Group may share User information with banks, payment gateways, NPCI, financial institutions, and government authorities or law enforcement agencies where required by law.</p>
                  <p>We also share data with technology service providers, affiliates, partners, and auditors engaged for operational support. <strong>DMT Group shall not sell or rent Personal Information to third parties for unauthorized commercial purposes.</strong></p>
                </div>

                {/* Section 5 */}
                <div className="tk-legal-section">
                  <h3 className="tk-section-title">5. Cookies & Tracking Technologies</h3>
                  <p className="mb-0">The Platform may use cookies, web beacons, and analytics tools to enhance user experience, improve security, and analyze web traffic. Users may choose to disable cookies through browser settings; however, certain features of the Platform may not function properly.</p>
                </div>

                {/* Section 6 */}
                <div className="tk-legal-section">
                  <h3 className="tk-section-title">6. Data Security</h3>
                  <p>DMT Group implements reasonable security practices and procedures to safeguard User information against unauthorized access, misuse, alteration, or destruction. Security measures include encryption technologies, secure firewalls, access control mechanisms, and periodic security audits.</p>
                  <p className="tk-sub-note-secure">🛡️ While DMT Group strives to protect User information using elite standards, no electronic transmission or storage system can be guaranteed as completely secure.</p>
                </div>

                {/* Section 7 */}
                <div className="tk-legal-section">
                  <h3 className="tk-section-title">7. Data Retention</h3>
                  <p className="mb-0">User information shall be retained only for as long as necessary to fulfill business purposes, comply with legal/regulatory obligations, or as required under RBI, NPCI, tax, or other applicable corporate regulations.</p>
                </div>

                {/* Section 8 */}
                <div className="tk-legal-section">
                  <h3 className="tk-section-title">8. Third-Party Links & Services</h3>
                  <p className="mb-0">The Platform may contain links to external websites. DMT Group does not control or assume responsibility for the privacy practices, policies, or content of such third-party platforms. Review their individual terms before sharing data.</p>
                </div>

                {/* Section 9 */}
                <div className="tk-legal-section">
                  <h3 className="tk-section-title">9. User Rights</h3>
                  <p>Subject to applicable law, Users may access, review, or request correction of inaccurate Personal Information. Users can withdraw consent where legally permissible or request deletion of information, subject to regulatory compliance obligations.</p>
                </div>

                {/* Section 10 */}
                <div className="tk-legal-section">
                  <h3 className="tk-section-title">10. Communications & Marketing</h3>
                  <p className="mb-0">We may send transactional updates, account alerts, newsletters, and promotional messages via SMS, email, WhatsApp, or push notifications. Users may opt out of promotional tracks, but critical service alerts will continue.</p>
                </div>

                {/* Section 11 */}
                <div className="tk-legal-section">
                  <h3 className="tk-section-title">11. Children’s Privacy</h3>
                  <p className="mb-0">The Platform is not intended for use by minors without lawful parental or guardian consent. DMT Group does not knowingly collect information from children in violation of applicable law.</p>
                </div>

                {/* Section 12 */}
                <div className="tk-legal-section">
                  <h3 className="tk-section-title">12. Changes to this Policy</h3>
                  <p className="mb-0">DMT Group reserves the right to modify, update, or revise this Privacy Policy at any time without prior notice. Continued use of the Platform after updates constitutes full acceptance of the revised Policy.</p>
                </div>

                {/* Section 13 */}
                <div className="tk-legal-section">
                  <h3 className="tk-section-title">13. Grievance Redressal</h3>
                  <p className="mb-0">For any queries, concerns, or grievances relating to this Policy or data handling, Users may contact DMT Group through the official support or grievance redressal channels available on the respective websites.</p>
                </div>

                {/* Section 14 */}
                <div className="tk-legal-section mb-0">
                  <h3 className="tk-section-title">14. Governing Law</h3>
                  <p className="mb-0">This Privacy Policy shall be governed by and construed in accordance with the laws of India. Any disputes arising in relation to this Policy shall be subject to the exclusive jurisdiction of the competent courts located in <strong>New Delhi, India</strong>.</p>
                </div>

                <div className="tk-privacy-footer-note">
                  <h5>Thank you for trusting DMT Group of Companies.</h5>
                </div>

              </div>
            </div>

          </div>
        </div>
      </section>
    </div>
  );
};

export default PrivacyPolicy;